<script setup>
import { defineProps, computed, defineEmits, inject } from 'vue';
import { ExportStatus } from '@/commons/enumExport.js';
import { I18nInjectionKey } from 'vue-i18n';

const { t } = inject(I18nInjectionKey);

const props = defineProps({
  name: {
    type: String,
    default: '',
  },

  status: {
    type: Number,
    default: 1,
  },

  id: {
    type: String
  }
});

/**
 * lấy icon trạng thái tiến trình theo status
 * created by lkphuc 13.03.2023
 */
const statusClass = computed(() => {
  if(!props.status) {
    return 'ic_export-loading';
  }
  switch(props.status) {
    case ExportStatus.Fail:
      return 'ic_export-failure';
    case ExportStatus.Success:
      return 'ic_export-success';
    default:
      return 'ic_export-loading';
  }
});

/**
 * build tên tiến trình theo status và tên file xuất khẩu
 * created by lkphuc 13.03.2023
 */
const processName = computed(() => {
  return props.name;
})

const emits = defineEmits(['remove']);

/**
 * emit sự kiện khi người dùng click nút x
 * created by lkphuc 13.03.2023
 */
const removeClick = () =>  {
  emits('remove', props.id);
}

</script>

<template>
  <div class="process-item" :data-id="id">
    <div class="process-item__status icon24" :class="statusClass" />
    <div class="process-item__text" :title="processName">
      {{ processName }}
    </div>
    <div class="process-item__delete icon20 ic_close-grey-16" @click.prevent="removeClick" />
  </div>
</template>



<style lang="scss" scoped>
@import '@/assets/scss/components/MsExportProcess.scss';
</style>